import { createGlobalStyle } from 'antd-style';

const AppShellStyles = createGlobalStyle({
  '#root': {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',

    '> .ant-app': {
      height: '100%',
    },
  },
});

export default AppShellStyles;
